( function( $, window ) {
	'use strict';

	var $backToTop;
	var $footer;
	var $main;
	var visibleClassName = 'is-visible';
	var stoppedClassName = 'is-stopped';
	var padding = 60;
	var resizeTimer;

	function positionElement() {
		if ( $( window ).scrollTop() > $main.offset().top ) {
			$backToTop.addClass( visibleClassName );

			if ( $( window ).scrollTop() >= ( $footer.offset().top - $( window ).height() ) ) {
				$backToTop.addClass( stoppedClassName );
			} else {
				$backToTop.removeClass( stoppedClassName );
			}
		} else {
			$backToTop.removeClass( visibleClassName );
		}
	}

	function registerResizeHandler() {
		$( window ).on( 'resize.qrc.backtotop', function() {
			clearTimeout( resizeTimer );
			resizeTimer = setTimeout( function() {
				positionElement();
			}, 250 );
		} );
	}

	function registerClickHandler() {
		$backToTop.on( 'click', function( event ) {
			event.preventDefault();

			$( 'html, body' ).animate( {
				scrollTop: 0
			}, 800 );
		} );
	}

	function registerScrollHandler() {
		$( window ).on( 'scroll', function() {
			positionElement();
		} );
	}

	$( function() {
		$backToTop = $( '.js-back-to-top' );
		$footer = $( '.js-site-footer' );
		$main = $( '.js-site-main' );

		if ( $backToTop.length && $main.length ) {
			positionElement();
			registerResizeHandler();
			registerClickHandler();
			registerScrollHandler();
		}
	} );
} )( jQuery, window );
